<template>
  <div id="sendTicket">
    <nav-bar/>
    <div class="container">
      <div class="row page-padding">
        <div class="col-md-4 col-sm-6 col-12">
          <div class="mb-2">عنوان:</div>
          <v-text-field
              outlined
              v-model="subject"
              dense
              flat
              hide-details
              color="primary"
              placeholder="عنوان را وارد کنید">
          </v-text-field>
          <div v-if="subject === null" class="validator font12px mt-1 mr-1">پر کردن این فیلد اجباریست.</div>

        </div>
        <div class="col-md-4 col-sm-6 col-12">
          <div class="mb-2">دسته بندی:</div>
          <v-autocomplete
              outlined
              dense
              hide-details
              color="primary"
              :items="categoryItems"
              v-model="categoryModel"
              item-text="Name"
              item-value="TicketCategoryId"
              placeholder="دسته بندی را انتخاب کنید">
          </v-autocomplete>
          <div v-if="categoryModel === null" class="validator font12px mt-1 mr-1">پر کردن این فیلد اجباریست.</div>

        </div>
        <div v-if="showPersonnelField" class="col-md-4 col-sm-6 col-12">
          <div class="mb-2">کاربر:</div>
          <v-autocomplete
              outlined
              flat
              dense
              hide-details
              color="primary"
              :items="UserItems"
              v-model="userModel"
              item-text="fullName"
              item-value="Id"
              placeholder="کاربر را انتخاب کنید">
          </v-autocomplete>
          <div v-if="userModel === null" class="validator font12px mt-1 mr-1">پر کردن این فیلد اجباریست.</div>
        </div>

        <div class="col-12">
          <div class="my-2">فایل: (شما میتوانید 5 فایل یا کمتر آپلود کنید)</div>
          <div class="row">
            <div class="col">
              <v-file-input id="fileInput1"
                            name="fileInput1" placeholder="فایل1" show-size outlined dense hide-details
                            append-icon="fa-paperclip"
                            prepend-icon=""></v-file-input>
            </div>
            <div class="col">
              <v-file-input id="fileInput2"
                            name="fileInput2" placeholder="فایل2" outlined dense hide-details append-icon="fa-paperclip"
                            prepend-icon=""></v-file-input>
            </div>
            <div class="col">
              <v-file-input
                  id="fileInput3"
                  name="fileInput3" placeholder="فایل3" outlined dense hide-details append-icon="fa-paperclip"
                  prepend-icon=""></v-file-input>
            </div>
            <div class="col">
              <v-file-input id="fileInput4"
                            name="fileInput4" placeholder="فایل4" outlined dense hide-details append-icon="fa-paperclip"
                            prepend-icon=""></v-file-input>
            </div>
            <div class="col">
              <v-file-input id="fileInput5"
                            name="fileInput5" placeholder="فایل5" outlined dense hide-details append-icon="fa-paperclip"
                            prepend-icon=""></v-file-input>
            </div>
          </div>

        </div>
        <div class="col-6">
          <div class="mb-2">توضیحات:</div>
          <editor-content :editor="description" class="text-editor"/>
          <div v-if="description !== null && description.getHTML() === '<p></p>'" class="validator font12px mt-1 mr-1">
            پر کردن این فیلد اجباریست.
          </div>
        </div>
        <div class="col-6 text-center align-self-end">

          <v-btn v-if="$getUserData().role !== 5"
                 :disabled="userModel === null || categoryModel === null || subject === null || description.getHTML() === '<p></p>'"
                 outlined color="primary" class="cards-btn" @click="defineTicket">ارسال
            تیکت
          </v-btn>
          <v-btn v-else :disabled="categoryModel === null || subject === null || description.getHTML() === '<p></p>'"
                 outlined color="primary" class="cards-btn" @click="defineTicket">ارسال
            تیکت
          </v-btn>
        </div>
      </div>
    </div>
    <v-dialog
        v-model="showResultDialog"
        hide-overlay
        persistent
        width="530">
      <v-card class="text-center">
        <v-card-title class="justify-space-between primary-bg">
          <v-btn
              color="primary"
              icon
              small
              @click="showResultDialog = false"
          >
            <i class="fas fa-times font-16 ml-1"></i>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-6">
          <div class="mb-0 black--text py-5">{{ dialogResult }}</div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-overlay
        v-model="showLoaderDialog"
        persistent
        width="500">
      <v-progress-circular
          color="white"
          indeterminate
          size="50"
      ></v-progress-circular>
    </v-overlay>

  </div>
</template>

<script>
import NavBar from "@/Ticketing/components/navBar";
import {Editor, EditorContent} from "tiptap";

export default {
  name: "sendTicket",
  components: {NavBar, EditorContent},
  metaInfo() {
    return {
      title: 'تیکتینگ-ارسال تیکت '
    }
  },
  data: () => ({
    categoryItems: [],
    UserItems: [],
    subject: null,
    userModel: null,
    description: null,
    dialogResult: null,
    categoryModel: null,
    showLoaderDialog: false,
    isLoggedIn: false,
    showPersonnelField: false,
    showResultDialog: false,
  }),
  mounted() {
    this.getTicketsCategory()
    this.getAllUsers()

    this.description = new Editor({
      content: '',
    })
    console.log("this.description.getHTML()")
    console.log(this.description.getHTML())
    if (this.$getUserData().role !== 5) {
      this.showPersonnelField = true
    }
  },
  methods: {
    getAllUsers() {
      this.showLoaderDialog = true

      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Client/ListAllUsers", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.UserItems = json
            for (let i = 0; i < json.length; i++) {
              json[i].fullName = json[i].Name + " " + json[i].Family;
            }
            this.showLoaderDialog = false
          })
          .catch(error => console.log('error', error));
    },
    getTicketsCategory() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Client/GetActiveTicketCategories", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.categoryItems = JSON.parse(result)
            this.showLoaderDialog = false
          })
          .catch(error => console.log('error', error));
    },
    defineTicket() {
      // For clients
      if (this.$getUserData().role === 5) {
        this.showLoaderDialog = true
        let resStatus = null
        let myHeaders = new Headers();
        myHeaders.append("Authorization", this.$getUserData().token);

        let formdata = new FormData();
        formdata.append("Subject", this.subject);
        formdata.append("Description", this.description.getHTML());
        formdata.append("TicketCategoryId", this.categoryModel);
        if (document.getElementById('fileInput1').files[0] !== undefined) {
          formdata.append("File1", document.getElementById('fileInput1').files[0]);
        }
        if (document.getElementById('fileInput2').files[0] !== undefined) {
          formdata.append("File2", document.getElementById('fileInput2').files[0]);
        }
        if (document.getElementById('fileInput3').files[0] !== undefined) {
          formdata.append("File3", document.getElementById('fileInput3').files[0]);
        }
        if (document.getElementById('fileInput4').files[0] !== undefined) {
          formdata.append("File4", document.getElementById('fileInput4').files[0]);
        }
        if (document.getElementById('fileInput5').files[0] !== undefined) {
          formdata.append("File5", document.getElementById('fileInput5').files[0]);
        }
        for (const [key, value] of formdata.entries()) {
          console.log(key, value)
        }

        let requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: formdata,
          redirect: 'follow'
        };

        fetch(this.$baseUrl + "/Client/SubmitClientTicket", requestOptions)
            .then(response => {
              resStatus = response.status
              return response.text()
            })
            .then(result => {
              if (resStatus === 401) {
                this.showLoaderDialog = false
                this.$router.replace({path: '/'})
              }
              if (resStatus === 200) {
                this.showLoaderDialog = false
                this.dialogResult = result
                this.$router.push({path: 'listTickets'})
              } else {
                this.showResultDialog = true
                this.dialogResult = result
              }
            })
            .catch(error => console.log('error', error));
      }
      else {

        this.showLoaderDialog = true
        let resStatus = null
        let myHeaders = new Headers();
        myHeaders.append("Authorization", this.$getUserData().token);

        let formdata = new FormData();
        formdata.append("Subject", this.subject);
        formdata.append("Description", this.description.getHTML());
        formdata.append("TicketCategoryId", this.categoryModel);
        // formdata.append("AgentUserId", this.userModel);
        formdata.append("AppUserId", this.userModel);
        if (document.getElementById('fileInput1').files[0] !== undefined) {
          formdata.append("File1", document.getElementById('fileInput1').files[0]);
        }
        if (document.getElementById('fileInput2').files[0] !== undefined) {
          formdata.append("File2", document.getElementById('fileInput2').files[0]);
        }
        if (document.getElementById('fileInput3').files[0] !== undefined) {
          formdata.append("File3", document.getElementById('fileInput3').files[0]);
        }
        if (document.getElementById('fileInput4').files[0] !== undefined) {
          formdata.append("File4", document.getElementById('fileInput4').files[0]);
        }
        if (document.getElementById('fileInput5').files[0] !== undefined) {
          formdata.append("File5", document.getElementById('fileInput5').files[0]);
        }

        let requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: formdata,
          redirect: 'follow'
        };

        fetch(this.$baseUrl + "/Client/SubmitPersonnelTicket", requestOptions)
            .then(response => {
              resStatus = response.status
              return response.text()
            })
            .then(result => {

              if (resStatus === 401) {
                this.showLoaderDialog = false
                this.$router.replace({path: '/'})
              }
              if (resStatus === 200) {
                this.showLoaderDialog = false
                this.dialogResult = result
                if (this.$getUserData().role === 5) {
                  this.$router.push({path: 'listTickets'})
                } else {

                  this.$router.push({path: 'listClientTicket'})
                }
              }
              else {
                this.showResultDialog = true
                this.dialogResult = result
              }
            })
            .catch(error => console.log('error', error));
      }

    },
  }
}
</script>

<style scoped>

</style>